<template>
  <div
    v-if="loading"
    class="content"
  >
    <div class="loading">
      <div class="loader" />
    </div>
  </div>
  <div
    v-else
    class="content"
  >
    <div class="md-layout">
      <!-- <div class="md-layout-item md-medium-size-100 md-size-100">
        <entity-card> </entity-card>
      </div> -->


      <div class="md-layout-item md-medium-size-100 md-size-100">
        <form>
          <md-card>
            <md-card-header data-background-color="green">
              <h4 class="title">
                #{{ item.name }}
              </h4>
              <!-- <p class="category" v-if="this.user.glpiactiveprofile!='Leitura'">Preencha com a solução</p> -->
            </md-card-header>


            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Nome</label>
                    <md-input v-model="item.name" />
                  </md-field>
                </div>



                <!-- <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field>
                    <label>Tipo</label>
                    <md-input v-model="item.type" disabled></md-input>
                  </md-field>
                </div> -->

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field>
                    <label>Tipo</label>
                    <md-select
                      id="type"
                      v-model="item.type"
                      name="type"
                    >
                      <md-option
                        v-for="type in types"
                        :key="type.name"
                        :value="type.name"
                      >
                        {{ type.name }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>




                <!-- <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Fabricante</label>
                    <md-input v-model="item.fab" disabled></md-input>
                  </md-field>
                </div> -->
                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Fabricante</label>
                    <!-- <md-input v-model="item.fab" disabled></md-input> -->
                    <md-select
                      id="manufacturer"
                      v-model="item.fab"
                      name="manufacturer"
                    >
                      <md-option
                        v-for="type in manufacturers"
                        :key="type.name"
                        :value="type.name"
                      >
                        {{ type.name }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Fornecedor</label>
                    <md-input v-model="item.supplier" />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Unidade</label>
                    <md-input v-model="item.unity" />
                  </md-field>
                </div>

                <!-- <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Localização</label>
                    <md-input v-model="item.location" ></md-input>
                  </md-field>
                </div> -->

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Localização</label>
                    <!-- <md-input v-model="item.location" disabled></md-input> -->
                    <md-select
                      id="location"
                      v-model="item.location"
                      name="location"
                    >
                      <md-option
                        v-for="type in locations"
                        :key="type.name"
                        :value="type.name"
                      >
                        {{ type.name }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Data de Inventário</label>
                    <md-input
                      v-model="item.date"
                      type="datetime-local"
                    />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Especificação técnica</label>
                    <md-input v-model="item.ref" />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Valor unitário (R$)</label>
                    <!-- <md-input v-model="item.value" ></md-input> -->
                    <md-input
                      v-model="item.value"
                      type="number"
                    />
                  </md-field>
                </div>




                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Quantidade de item e estoque ({{ this.item.unity }})</label>
                    <md-input
                      v-model="item.new"
                      type="number"
                    />
                  </md-field>
                </div>



                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Consumo acumulado total ({{ this.item.unity }})</label>
                    <md-input
                      v-model="item.total"
                      type="number"
                      disabled
                    />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Consumo acumulado últimos 12 meses ({{ this.item.unity }})</label>
                    <md-input
                      v-model="item.lastYear"
                      type="number"
                      disabled
                    />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Leadtime (dias)</label>
                    <!-- <md-input v-model="item.leadtime" ></md-input> -->
                    <md-input
                      v-model="item.leadtime"
                      type="number"
                    />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Estoque mínimo ({{ this.item.unity }})</label>
                    <md-input
                      v-model="item.min"
                      type="number"
                    />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Opção de Cálculo automático</label>
                    <md-select
                      id="movie"
                      v-model="item.auto"
                      name="movie"
                    >
                      <md-option value="1">
                        ATIVADO
                      </md-option>
                      <md-option value="0">
                        DESATIVADO
                      </md-option>
                    </md-select>
                  </md-field>
                </div>

                <!-- <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field maxlength="5">
                    <label>Comentário</label>
                    <md-input v-model="item.comment" ></md-input>
                  </md-field>
                </div> -->




                <div
                  v-if="this.user.glpiactiveprofile!='Leitura'"
                  class="md-layout-item md-size-100 text-right"
                >
                  <md-button
                    class="md-raised md-success"
                    @click="fillData()"
                  >
                    SALVAR
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header data-background-color="green">
          <h4 class="title">
            Evolução - Utilização
          </h4>
        </md-card-header>
        <div id="chart">
          <apexcharts
            :options="apexOptionsTicketsEvolution"
            :series="this.apexSeries3"
          />
        </div>
      </md-card>
    </div>
  </div>
</template>

<script>
import { userService } from "../_services";
import VueApexCharts from "vue-apexcharts";

import { getUserSession } from "../_services/localstorage";

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {
      id: 0,
      glpiActiveEntity:0,
      loading: true,

      item:{
        id:0,
        name:"",
        ref:"",
        type:"",
        fab:"",
        used:0,
        new:0,
        location:"",
        min:0,
        comment:"",
        date:"",
        lastYear:0,
        total:0,
        value:0,
        leadtime:0,
        auto:0,
        unity:"PÇ",
        supplier:"",
      },
      consumption:[],
      quantityref:0,
      apexOptionsTicketsEvolution: {
          chart: {
          type: "bar",
          height: 350,
          stacked: false,
          toolbar: {
            show: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"]
        },
        xaxis: {
          categories: ["Jan", "Fev", "Mar","Abr","Mai","Jun", "Jul","Ago","Set","Out","Nov","Dez"],
          labels: {
            formatter: function (val) {
              return val;
            }
          }
        },
        yaxis: {
          title: {
            text: "",
          },
        },
        tooltip: {
          tools: { download: true },
          y: {
            formatter: function (val) {
              return val;
            }
          }
        },
        theme: {
           palette: "palette2"
         },
        fill: {
          opacity: 1
        },
        legend: {
          position: "bottom",
          horizontalAlign: "left",
          offsetX: 40
        }
      },
      apexSeries3:[],
      locations:[],
      manufacturers:[],
      types:[],


    };
  },
  created: function() {
      this.id = this.$route.params.id;
      this.loading=true;
      this.returnUrl =  "/consumables";
      // console.log(this.id)
      this.user = getUserSession();
      this.glpiActiveEntity=this.user.activeentity;
      this.getInfo();
      this.timer = setInterval(this.checkSite, 1000);

  },
  methods:{
    getInfo(){
      this.loading=true;

      userService.getConsumableItemType(this.user.token).then(searchResult => {
        // console.log(searchResult.glpiConsumableItem);
        this.types=searchResult.glpiConsumableItem;
        // console.log(this.types)
      });

      userService.getManufacturer(this.user.token).then(searchResult => {
        // console.log(searchResult.glpiConsumableItem);
        this.manufacturers=searchResult.glpiConsumableItem;
        // console.log(this.manufacturers)
      });

      userService.getLocation(this.user.token).then(searchResult => {
        // console.log(searchResult.glpiConsumableItem);
        this.locations=searchResult.glpiConsumableItem;
        // console.log(this.locations)
      });

      userService.getConsumableItem(this.user.token,this.id ).then(searchResult => {
        // console.log(searchResult);

        this.item=searchResult;
        this.quantityref=this.item.new;
        if(this.item==null){
          this.$router.push(this.returnUrl);
        }


        userService.getConsumableItemInfo(this.user.token,this.id ).then(searchResult => { this.item.date= searchResult;});

        userService.getConsumableList(this.user.token,this.id ).then(searchResult => {


          // console.log(searchResult);
          var j=0,swapdate,swapposition;
          var now = new Date();
          var swapHistoryYear=now.getFullYear()-1-2000;
          now.setFullYear(now.getFullYear()-1);
          // console.log(now.toLocaleDateString())
          // console.log(searchResult)
          this.consumption=Array(12).fill(0);
          var swapMonth2=[],swapMonth=[
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez"
          ];
          var date_comp;
          if(now.getMonth()<=9){
            date_comp=(now.getFullYear()).toString()+"-0"+(now.getMonth()+1).toString();
          }
          else{
            date_comp=(now.getFullYear()).toString()+"-"+(now.getMonth()+1).toString();
          }
          // console.log(date_comp)
          for (j = 0; j < searchResult.length; j++) {
            if(searchResult[j].date_out!=null  && searchResult[j].date_out.search(date_comp)==-1){

              swapdate = searchResult[j].date_out.split("-");
              swapdate = new Date(swapdate[0],swapdate[1],swapdate[2]);
              // console.log(swapdate.toLocaleDateString())
              if(swapdate>now){
                  // console.log(swapdate)
                  this.item.lastYear=this.item.lastYear+1;
                  swapposition=(swapdate.getMonth()-now.getMonth()-2);
                  if(swapposition<0){
                    swapposition=swapposition+12;
                  }
                  this.consumption[swapposition]=this.consumption[swapposition]+1;



              }

            }

          }
          now.setFullYear(now.getFullYear()+1);
          for (j = (now.getMonth()+1); j < now.getMonth()+13; j++) {

            if(j>11){

              swapMonth2.push(swapMonth[j%12]+"/"+(swapHistoryYear+1));
            }
            else{
              swapMonth2.push(swapMonth[j%12]+"/"+(swapHistoryYear));
            }

          }

          // console.log(swapMonth2)

          this.apexOptionsTicketsEvolution.xaxis.categories=swapMonth2;

          // console.log(this.consumption)
          this.apexSeries3=[{
            name:"Consumo",
            data:this.consumption
          }];
          this.loading=false;
          // console.log(this.item)

        });
      });
    },
    fillData () {

      for (var j = 0; j < this.locations.length; j++) {
        if(this.item.location==this.locations[j].name){
          this.item.location=this.locations[j].id;
        }
      }

      for (var j = 0; j < this.manufacturers.length; j++) {
        if(this.item.fab==this.manufacturers[j].name){
          this.item.fab=this.manufacturers[j].id;
        }
      }

      for (var j = 0; j < this.types.length; j++) {
        if(this.item.type==this.types[j].name){
          this.item.type=this.types[j].id;
        }
      }

      userService.updateConsumable(this.user.token,this.item).then(response => {
        // console.log(response);
        if(this.item.new>this.quantityref){
          // add consumables
          var quantity=this.item.new-this.quantityref;
          // remove consumables
          // console.log(this.item)
          userService.addConsumables(this.user.token,this.item.id,quantity).then(response => {
            // console.log(response);
            // this.$router.push(this.returnUrl)
            this.getInfo();
          });


        }
        if(this.item.new<this.quantityref){
          var quantity=this.quantityref-this.item.new;
          // remove consumables
          // console.log(this.item)
          userService.getAllConsumables(this.user.token).then(response => {
            userService.drawConsumableItem(this.user.token,this.item.id,response,quantity).then(response => {
              // console.log(response);
              // this.$router.push(this.returnUrl)
              this.getInfo();
            });
          });

        }


        this.getInfo();
        // this.$router.push(this.returnUrl)
      });


    },
    checkSite: function () {


      // console.log("check "+this.user.activeentity+ " > "+this.glpiActiveEntity)

      this.user = getUserSession();
      // console.log(this.user);
      // this.totalTickets=this.totalTickets+1;

      if(this.user.activeentity!=this.glpiActiveEntity){
        this.glpiActiveEntity=this.user.activeentity;

        this.loading=true;
        // console.log("Search1");
        this.getInfo();



      }
    },
    convertDate: function (str) {
      var date = new Date(str);
      return date.toLocaleDateString();

    },
  }
};
</script>

<style>


.apexcharts-menu-item.exportSVG {
  display: none;
}

.apexcharts-menu-item.exportPNG {
  display: none;
}


</style>
